<app-header></app-header>

<nav class="main-nav">
  <button class="nav-button" routerLink="/home" routerLinkActive="active">HOME</button>
  <button class="nav-button" routerLink="/about" routerLinkActive="active">ABOUT</button>
</nav>

<router-outlet></router-outlet>
<app-footer></app-footer>